import React from 'react'
import TeamMember from 'src/components/TeamMember'
import { TeamMemberQueryResult } from 'src/model/teamMemberQuery'
import { css } from 'src/style/css'
import { Theme } from 'src/style/Theme'

type TeamGridProps = {
    items: TeamMemberQueryResult[]
}

const TeamGrid = ({ items }: TeamGridProps) => {
    return (
        <div
            css={(th: Theme) => css`
                display: grid;
                gap: ${th.spacing.lg};
                justify-items: center;
                margin: 0 auto;

                // Mobile: 1 column
                grid-template-columns: 1fr;

                @media (min-width: 52em) {
                    // Tablet: 2 columns
                    grid-template-columns: repeat(2, 1fr);

                    // Left-align lone item in last row (2-col layout)
                    & > :nth-last-child(1):nth-child(2n + 2) {
                        grid-column: 1;
                    }
                }

                @media (min-width: 70em) {
                    // Desktop: 4 columns
                    grid-template-columns: repeat(8, minmax(0, 1fr));

                    > * {
                        grid-column: span 2;
                    }

                    // Center incomplete final rows within the 4-column layout.
                    & > :nth-last-child(1):nth-child(4n + 1) {
                        grid-column: 4 / span 2;
                    }

                    & > :nth-last-child(2):nth-child(4n + 1) {
                        grid-column: 3 / span 2;
                    }

                    & > :nth-last-child(3):nth-child(4n + 1) {
                        grid-column: 2 / span 2;
                    }
                }
            `}
        >
            {items.map((item) => (
                <TeamMember {...item} key={item.id} />
            ))}
        </div>
    )
}

export default TeamGrid
